import { render, staticRenderFns } from "./CirculationProfileSchemaList.vue?vue&type=template&id=5f3c8c70&scoped=true&"
import script from "./CirculationProfileSchemaList.vue?vue&type=script&lang=js&"
export * from "./CirculationProfileSchemaList.vue?vue&type=script&lang=js&"
import style0 from "./CirculationProfileSchemaList.vue?vue&type=style&index=0&id=5f3c8c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c8c70",
  null
  
)

export default component.exports